import { graphql } from 'relay-runtime';

export const DatavalidationRuleDetailsQuery = graphql`
  query dataValidationRuleDetailsQuery($owner: String, $resourceName: String!) {
    validationRuleDetails(owner: $owner, resourceName: $resourceName) {
      resourceName
      displayName
      description
      provider
      connectorComponentRef {
        kind
        name
        version
      }
      ruleLibraryItemRef {
        kind
        name
        version
        rliType
      }
      categories
      status
      status_message
      generalProperties {
        propertyName
        propertyValue
        propertyValues
        externalObjectType
        order
        uiReadOnly
        visibility
        requiredField
        placeholderText
      }
      specificProperties {
        propertyName
        propertyValue
        propertyValues
        externalObjectType
        order
        uiReadOnly
        visibility
        requiredField
        placeholderText
      }
      notificationProperties {
        propertyName
        propertyValue
        propertyValues
      }
      checkId
      datastoreId
      containerId
    }
  }
`.default;
